import { Resource, Resources } from "./../../../models/resources";
import { RootState } from "src/redux/store";
import { useSelector } from "react-redux";
import { InformationAssetTableRecord } from "src/pages/information-assets/information-assets-list/assets-table/model/view-object";
import { useFetchAllSystemResources } from "../system-resources";
import { ApiCallState } from "src/common/ApiCall";
import { useFetchAllResourcesApiCallState } from "../../api-progress/resources";
import { useFetchAllSystemResourcesApiCallState } from "../../api-progress/system-resources";
export function useFetchAllResources(): Resources {
  const resources: Resource[] =
    useSelector((rootState: RootState) => rootState.resources.resourcesPEV.value.resources) ?? [];

  return new Resources(resources);
}

export function useInformationAssetListRecordGenerator(): InformationAssetTableRecord[]|null {
  const resources = useFetchAllResources();
  const systemResources = useFetchAllSystemResources();

  const fetchAllResourcesApiCallStatus: ApiCallState = useFetchAllResourcesApiCallState();
  const fetchAllSystemResourcesApiCallStatus: ApiCallState =
    useFetchAllSystemResourcesApiCallState();

  function isValueNotPresentDuringApiCall() {
    return (
      (resources.isResourceEmpty() || systemResources.isSystemResourceEmpty()) &&
      (fetchAllResourcesApiCallStatus.isApiCallLoading ||
        fetchAllSystemResourcesApiCallStatus.isApiCallLoading)
    );
  }

  if (isValueNotPresentDuringApiCall()) {
    return null
  }

  return resources
    .getResources()
    .map(
      (resource: Resource) =>
        new InformationAssetTableRecord(
          resource,
          systemResources.fetchAssociatedSystemResources(resource.id)
        )
    );
}
